import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import {
  GenericResponseCode,
  GenericResponseResult,
} from '@brighthub/api';
import {
  ClientProfileSaveSectionResponse,
} from './client-profile.model';

/**
 * Client profile mutations. Section loading uses {@link ClientProfileSectionsService}.
 */
@Injectable({
  providedIn: 'root',
})
export class ClientProfileService {
  /**
   * Save edited values for a single profile section.
   * Mock: simulates API call; replace with ApiService.patch when backend is ready.
   */
  saveProfileSection(
    guid: string,
    sectionId: string,
    values: Record<string, string | number>
  ): Observable<ClientProfileSaveSectionResponse & GenericResponseResult> {
    const savedKeys = Object.keys(values);
    return of({
      result: {
        status: 200,
        code: GenericResponseCode.SERVICE_OK,
        message: '',
        suggestion: '',
        suggestionCopyKey: '',
        docs: '',
      },
      payload: { sectionId, savedKeys },
    }).pipe(delay(600));
  }
}
